import { useRef } from "react"
import useComponentSize from "@rehooks/component-size"
import { observer } from "mobx-react-lite"

import { Search } from "@/components/search"
import { Switch } from "@/components/switch"
import { useScaleApplication } from "@/domains/application/use-scale-application"
import { SwitchDetailedMode } from "@/domains/common/components/switches/switch-detailed-mode"
import { SwitchMyPositions } from "@/domains/common/components/switches/switch-my-positions"
import { CompactIcon } from "@/domains/icons"
import { LiquidityTypeTabs } from "@/domains/liquidity-page/components/liquidity-type-tabs"
import { useGovernanceToken } from "@/hooks/use-governance-token"
import { useNativeToken } from "@/hooks/use-native-token"

export const TabletView = observer(() => {
  const scaleApp = useScaleApplication()
  const nativeToken = useNativeToken()
  const governanceToken = useGovernanceToken()
  const ref = useRef<HTMLDivElement>(null)
  const x = useComponentSize(ref)

  const canShowTypes = x.width > 800

  return (
    <div className="flex w-full justify-between gap-4" ref={ref}>
      <div className="text-t200 flex max-w-[30%] flex-grow items-center justify-start gap-3">
        <Search
          className="text-t200 w-full"
          placeholder={`${governanceToken.name}, ${nativeToken.name}, BTC, ETH, 0x...`}
          value={scaleApp.Pages.Liquidity.search}
          onChange={(e) => scaleApp.Pages.Liquidity.setSearchFromUi(e.target.value)}
        />
      </div>
      <SwitchDetailedMode
        checked={scaleApp.Pages.Liquidity.isDetailed}
        onCheckedChange={(value) => scaleApp.Pages.Liquidity.setIsDetailedFromUi(value)}
      />
      <SwitchMyPositions
        checked={scaleApp.Pages.Liquidity.stakedOnly}
        onCheckedChange={(value) => scaleApp.Pages.Liquidity.setStakedOnlyFromUi(value)}
      />

      <div className="text-t200 ml-auto flex w-fit items-center gap-3">
        {canShowTypes ? (
          <LiquidityTypeTabs
            value={scaleApp.Pages.Liquidity.poolType === "cl" ? "all" : scaleApp.Pages.Liquidity.poolType}
            onValueChange={(value) => scaleApp.Pages.Liquidity.setPoolTypeFromUi(value)}
            className="bg-p400"
          />
        ) : null}
      </div>
    </div>
  )
})
